export default __webpack_public_path__ + "static/media/BumpFund_Icons_06.8d281a1f.svg";